<template>
	<div></div>
</template>

<script>
import OT from '@opentok/client'
export default {
	name: 'screen-preview',
	props: {
		session: {
			type: OT.Session,
			required: false,
		},
		opts: {
			type: Object,
			required: false,
		},
	},
	mounted: function() {
		OT.checkScreenSharingCapability((response) => {
			if (!response.supported || response.extensionRegistered === false) {
				// This browser does not support screen sharing.
			} else if (response.extensionInstalled === false) {
				// Prompt to install the extension.
			} else {
				console.log('screen sharing is available')

				// Screen sharing is available. Publish the screen.
				// opts { videoSource: 'screen' },
				const publisher = OT.initPublisher(
					this.$el,
					this.opts,
					(err) => {
						if (err) {
							this.$emit('error', err)
						} else {
							this.$emit('publisherCompleted')
						}
					}
				)

				this.session.publish(publisher, (err) => {
					if (err) {
						this.$emit('error', err)
						console.log('Error al publicar', err)
					} else {
						this.$emit('publisherConnected', publisher)
					}
				})
			}
		})

		// const publisher = OT.initPublisher(this.$el, this.opts, (err) => {
		// 	if (err) {
		// 		this.$emit('error', err)
		// 	} else {
		// 		this.$emit('publisherCompleted')
		// 	}
		// })
		// this.$emit('publisherCreated', publisher)
		// const publish = () => {
		// 	this.session.publish(publisher, (err) => {
		// 		if (err) {
		// 			this.$emit('error', err)
		// 		} else {
		// 			this.$emit('publisherConnected', publisher)
		// 		}
		// 	})
		// }
		// if (this.session && this.session.isConnected()) {
		// 	publish()
		// }
		// if (this.session) {
		// 	this.session.on('sessionConnected', publish)
		// }
	},
}
</script>
